import { createContext } from "react";
const TabsContext = createContext({
  orientation: "horizontal",
  disabled: !1
});
export {
  TabsContext
};
//# sourceMappingURL=context.js.map
